import { AfterViewInit, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { PagarePDF, PagareConPlantilla } from 'app/models/pagare.model';
import { PdfService } from 'app/services/pdf.service';
import { take } from 'rxjs';

@Component({
    selector: 'group-pagare',
    templateUrl: './group-pagare.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class GroupPagareComponent implements OnInit, AfterViewInit {
    htmlToAdd: boolean = false;

    arrPagares: PagarePDF[];
    plantilla: string = 'PLANTILLA 1';
    plantillaHtml: string = null;
    loading: boolean = false;
    constructor(private actvatedRoute: ActivatedRoute, private _pdf: PdfService, private _sanitizer: DomSanitizer) {}
    ngOnInit() {
        this.loading = true;
        // obtenemos el code de la url
        let ID_PROCESO = this.actvatedRoute.snapshot.params.ID_PROCESO;
        let accessToken = this.actvatedRoute.snapshot.queryParams.accessToken || '';
        // seteamos el tipo de certificado en base al codigo
        // Generando el qr
        this._pdf.obtenerInfoPagareProceso(ID_PROCESO, accessToken).subscribe({
            next: (data: PagareConPlantilla) => {
                this.plantilla = data.PLANTILLA;
                this.arrPagares = data.PAGARES;
                this.obtenerPlantilla();
                this.loading = false;
            },
            error: (err: any) => {
                // console.log(err);
                this.plantilla = null;
                this.arrPagares = [];
                this.loading = false;
            },
        });
    }
    obtenerPlantilla() {
        this._pdf
            .obtenerPlantilla(this.plantilla)
            .pipe(take(1))
            .subscribe({
                next: (info) => {
                    this.plantillaHtml = info.plantillaHtml;
                },
                error: (err) => {
                    this.plantillaHtml = null;
                },
                complete: () => {},
            });
    }
    ngAfterViewInit () {
        //this.htmlToAdd = true
    }
}
